module.exports = __webpack_public_path__ + "logoWhite.webp?4ac449fdd7ae98193d6899e449dd7165";